// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bS-9","colBig":"styles_colBig__PewLK","colSmall":"styles_colSmall__37II5"};